import apiUrl from "../../../constants";
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {Validator} from 'vee-validate'
import VueAlertify from 'vue-alertify';
import {BasicSelect} from 'vue-search-select'
import VueElementLoading from 'vue-element-loading';
import { applySmartInputStyles, clearSmartInputStyles, createClearInputWatcher } from "../../../common/inputStyleHelper";

export default {
  name: 'agenthandover',
  components: {BasicSelect,VueElementLoading},
  props: [],
  data () {
    return {
      agentid:'',
      process:'',
      awb:'',
      awbArray:[],
      buttonLabel : 'InScan',
      obj:{},
      showTable: false,
      returnArray:[],
      input:{
          "EntityType": "Agent"
      },
      shipmentDetails:[],
      isInScanLoader: false,
      userDataKey : '',
      }
  },
  computed: {

  },
  watch: {
    awb: createClearInputWatcher('awb'),
  },
  mounted () {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.hubdetails = userdetail.hubdetails[0];
    this.mobilenumber = userdetail.mobilenumber;
    this.outsourcingid = userdetail.outsourcingid;
    this.localusermailid = userdetail.email;
    this.userfullname = userdetail.username;
    const vm = this;
    $("#awb").keydown(function (event) {
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if (keycode == 13) {
        // $("#formSubmit").click();
        vm.validateForm('form-1');
        return false;
        event.stopPropagation();
      }
    });
  },
  methods: {
    ChangeLabelName(){
      this.buttonLabel = this.process == 'Shortage' ? 'Mark Shortage' : 'InScan';
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(async result => {
        if (result) {
          this.isInScanLoader = true;
          let shippingidsWithNextLine = this.awb.split("\n").map(String);
          let shippingidsWithComma = this.awb.split(",").map(String);

          if(shippingidsWithNextLine.length > 1) {
            $.each(shippingidsWithNextLine, (key,sid)=>{
              if(sid != null && sid !=''){
                this.awbArray.push(sid.trim());
              }
            })
          } else if(shippingidsWithComma.length >= 1){
            $.each(shippingidsWithComma, (key,sid)=>{
              if(sid != null && sid !=''){
                this.awbArray.push(sid.trim());
              }
            })
            // this.awbArray = shippingidsWithNextLine.filter(function (sid) {
            //    return sid != null && sid !='';
            // });
          }
          console.log('this.awbArray',this.awbArray);
          this.obj.couriercompanyid = this.outsourcingid;
          this.obj.couriercompanyname = this.userfullname;
          this.obj.couriercompanyphone = this.mobilenumber;
          this.obj.process = this.process;
          this.obj.awb = this.awbArray;
          this.obj.createdby = "Agent";

          await axios.post(apiUrl.api_url +`AgentInscan/Inscan`,this.obj
           ).then(result => {
              applySmartInputStyles(document.getElementById('awb'), result.data.lossCategorization);
              if(result.data.code == 200 ) {
                this.showTable = true;
                this.returnArray = result.data.data;
                this.awb=''
                this.$validator.reset();
                this.errors.clear();
              } else {
                this.$validator.reset();
                this.errors.clear();
                this.$alertify.error(result.data.message);
              }
              this.isInScanLoader = false;
        })
        .catch((httpException) => {
            this.$alertify.error("Something went wrong!!");
            console.error('exception is:::::::::', httpException)
            this.isInScanLoader = false;
        });

        }
      }).catch(() => {
        console.log('errors exist', this.errors)
        this.isInScanLoader = false;
      });
    },
    resetForm(){
      this.agent=''
      this.agentname=''
      this.handovermode=''
      this.vehicleno=''
      this.process = ''
      this.handoverpersonname=''
      this.awb=''
      this.awbArray=[]
      this.obj={}
      this.showTable= false
      this.returnArray=[]
      this.isInScanLoader = false;
      clearSmartInputStyles(document.getElementById('awb'));
      this.$validator.reset();
      this.errors.clear();
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/agentinscan/agentinscan.component.js